export default "__VITE_ASSET__IMhASuYU__"